import { useEffect, useState } from 'react'

const TRANSITION_DURATION = 300 // Standard MUI transition duration in ms

export const useDelayedState = (state: boolean) => {
  const [isDelayedState, setDelayedState] = useState(state)

  useEffect(() => {
    const delay = state ? 0 : TRANSITION_DURATION
    const timeout = setTimeout(() => {
      setDelayedState(state)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [state])

  return {
    duration: TRANSITION_DURATION,
    isDelayedState,
  }
}
